import { FormattedMessage } from 'react-intl';
import { Alert, Button } from 'react-bootstrap';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginModalStep } from '../../../sell/actions/sell-tickets';
import { doSocialConnect } from '../../actions/auth';
import { selectLoginModalStep } from '../../../sell/selectors/sell-tickets';
import IABILET_LOGO from '../../assets/img/iabilet-blue.svg';
import { CONNECT_IABILET } from '../../../sell/api/config';
import { LOGIN_STEP_1 } from '../../../sell/constants/modal';

const LoginContentStep3 = ({ targetPath }) => {
    const dispatch = useDispatch();
    const step = useSelector(selectLoginModalStep);
    return (
        <>
            {step ? <Alert variant="info" className="mt-3 mb-4"><FormattedMessage id="connect_iabilet_account"/></Alert>
                : <Alert variant="light" className="mt-3 mb-4"><FormattedMessage id="connect_modal_desc"/></Alert>}
            <div className="d-grid gap-2">
                <Button variant="outline-dark" size="lg"
                    onClick={() => doSocialConnect(CONNECT_IABILET, targetPath)}>
                    <FormattedMessage id="connect_with"/>
                    <img src={IABILET_LOGO} alt="IaBilet" className="logo-iabilet img-fluid ms-2"/>
                </Button>
            </div>
            <div className="mt-3 d-flex justify-content-center text-center">
                <FormattedMessage id="already_have_account"/>
                <span className="link-primary ms-2"
                    onClick={() => dispatch(setLoginModalStep(LOGIN_STEP_1))}>
                    <FormattedMessage id="login"/>
                </span>
            </div>
        </>
    );
};
export default LoginContentStep3;
